import { JsonFetch } from "@roc-digital/mxm-base/logic";
import { AUX_API } from '@/env';

interface UserSubscriptionStatus {
  subscription_end?: number;
  provider?: string;
  status?: string;
  status_hint?: string;
  start_date?: number;
  product?: string;
}

export async function readUserSubscriptionStatus(userId: string) {
  return await JsonFetch<UserSubscriptionStatus>({
    method: 'GET',
    url: `${AUX_API}/users/${userId}/subscription-status`,
  });;
}
